// extracted by mini-css-extract-plugin
export default {"container":"fr-z","paperCuts":"gr-z","brandName":"hr-z","productName":"ir-z","breakLongProductName":"jr-z"};